const MyProfile = () => (
  <div className="my-profile">
    <h1>Welcome to My Profile Page</h1>
  </div>
);

export default MyProfile;
